import router from './router'
import useProductAttributeStore from './store'
import ProductAttributeMessages from './localization'

export default {
  router,
  useProductAttributeStore,
  localization: ProductAttributeMessages,
}
